import './Page.scss'
import React from 'react'

export default ({ children, id, collapsed }) => (
  <div id={ id } className={"page collapsed-" + collapsed}>
    { children }
  </div>
)
